"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runningMan = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var avatars_1 = require("components/Avatar/avatars");
require("./style.scss");
exports.runningMan = '/assets/images/Business_man_run_cycle_transparent.gif';
exports.default = (function (props) {
    if (props.translations.status === 'FAILURE' && props.translations.reason) {
        if (props.translations.reason.type !== 'API_ERROR') {
            return (React.createElement("div", { className: 'loading-view maintenance' },
                React.createElement("div", null,
                    React.createElement("img", { src: '/assets/images/maintenance.svg' })),
                React.createElement("div", null, "\u00A0")));
        }
        else {
            return (React.createElement("div", { className: 'loading-view' },
                React.createElement("div", { className: 'loading-view-error' },
                    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_19') }),
                    React.createElement("h3", null, "We are unable to fetch all information"),
                    React.createElement("span", null, "Please try again later"))));
        }
    }
    if (props.userStatus !== undefined && props.userStatus.status === 'FAILED') {
        return (React.createElement("div", { className: 'loading-view' },
            React.createElement("div", { className: 'loading-view-error' },
                React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_19') }),
                React.createElement("h3", null, (0, translation_1.getLocalization)('userFront/loadingView/unableToFetchUser')),
                React.createElement("span", null,
                    (0, translation_1.getLocalization)('userFront/loadingView/pleaseContact'),
                    ' ',
                    React.createElement("a", { href: 'mailto:helpdesk@sokopro.fi' }, (0, translation_1.getLocalization)('userFront/loadingView/contactHelpdesk'))))));
    }
    return (React.createElement("div", { className: 'loading-view' },
        React.createElement("img", { className: "icon", src: exports.runningMan })));
});
